import React, { useState, useEffect } from 'react';
import { useDeepEqualSelector } from 'Shared/utils/hooks';
import { FeedbackTypes } from 'Shared/constants/types';

import KudosPreviewModal from './KudosPreviewModal/KudosPreviewModal';

export default function KudosNotificationModule() {
  const [webNotificationToDisplay, setWebNotificationToDisplay] = useState(null);

  const webNotification = useDeepEqualSelector(state => {
    return state.web_notifications.filter(
      notification => notification?.data?.type === FeedbackTypes.kudos && !notification?.readAt
    )[0];
  });

  const setIsOpen = value => {
    if (value === false) setWebNotificationToDisplay(null);
  };

  useEffect(() => {
    if (webNotification) {
      setWebNotificationToDisplay(webNotification);
    }
  }, [webNotification]);

  return webNotificationToDisplay ? (
    <KudosPreviewModal isOpen setIsOpen={setIsOpen} notification={webNotificationToDisplay} />
  ) : null;
}
